import * as React from 'react';
import { Grid } from '@material-ui/core';
import { Button } from '@one-thd/sui-atomic-components';
import { LazyImage } from '../../shared/LazyImage';
import { links } from '../../../constants/LegacyTiers';
import { pkPLCCBanner } from '../../../constants/ProXtraPerks';
import { getImageURL } from '../../../utils/GeneralUtil';
import { setOverlayEvent, stashLinkEvent } from '../../../utils/analytics';
var renderToolTipMessage = function () { return (React.createElement("div", { className: "PerkPLCC__toolTipMessage" },
    React.createElement(Grid, { className: "PerkPLCC__modalToolTipHeader" }, pkPLCCBanner.plccModalTooltipQualifying),
    React.createElement(Grid, null, pkPLCCBanner.plccModalTooltip),
    React.createElement("br", null),
    React.createElement("p", null,
        "For full details, see the\u00A0",
        React.createElement("a", { className: "u__default-link", href: links.faqTermsAndConditions, target: "_blank", rel: "noreferrer" }, links.termsAndConditionsTitle)))); };
export var renderTooltip = function () { return (React.createElement(React.Fragment, null,
    React.createElement("div", { className: "info-tooltip" },
        React.createElement("img", { src: getImageURL('ProTiers/icon-info.svg'), alt: "plcc-tooltip-icon", width: "16px", height: "16px", className: "info-tooltip-icon" }),
        React.createElement("div", { className: "PerkPLCC__toolTip bottom tooltip-text" },
            React.createElement("div", null, renderToolTipMessage()),
            React.createElement("i", null))))); };
export var DesktopCardBanner = function (data) {
    var plccSwitch = data.plccSwitch, setTogglePLCC = data.setTogglePLCC, activePxccFactor = data.activePxccFactor, acquisitionSwitch = data.acquisitionSwitch;
    var handleClick = function () {
        stashLinkEvent('perks: pxcc enrolled: member banner');
        setTogglePLCC(true);
    };
    return (React.createElement(Grid, { container: true, className: "PerkPLCC__box" },
        React.createElement(Grid, { item: true, className: "PerkPLCC__leftBox" },
            React.createElement(Grid, { item: true, className: "PerkPLCC__cardLogoBox" },
                React.createElement(Grid, { className: "PerkPLCC__inner-circle" },
                    activePxccFactor,
                    "X"),
                React.createElement(LazyImage, { src: getImageURL('PrgDetails/card.png'), classes: "PerkPLCC__cardLogo", altText: "Top banner, Home Depot store" })),
            React.createElement(Grid, { container: true, className: "PerkPLCC__labelBox" },
                React.createElement(Grid, { className: "PerkPLCC__LabelHeading" }, plccSwitch
                    ? 'Welcome Back, Pro Xtra Credit Card Member'
                    : "You Could Be Earning Pro Xtra Perks ".concat(activePxccFactor, "X Faster.")),
                React.createElement(Grid, { className: "PerkPLCC__LabelSubHeading" }, plccSwitch
                    ? "You\u2019re Earning ".concat(activePxccFactor, "X Towards Perks with every qualifying purchase.")
                    : 'Find out more about the Pro Xtra Credit Card.'))),
        React.createElement(Grid, { item: true, className: "PerkPLCC__rightBox" },
            acquisitionSwitch && (React.createElement(Grid, null,
                React.createElement(LazyImage, { src: getImageURL('banner-bg-PLCC-NotEnrolled.svg'), classes: "PerkPLCC__cardbanner", altText: "Top banner, Home Depot store" }))),
            React.createElement(Grid, { item: true, className: "PerkPLCC__detailsBox" },
                React.createElement(Button, { variant: "text", onClick: handleClick }, "See All")))));
};
export var MobileCardBanner = function (data) {
    var plccSwitch = data.plccSwitch, setTogglePLCC = data.setTogglePLCC, activePxccFactor = data.activePxccFactor;
    var handleBannerClick = function () {
        setTogglePLCC(true);
        stashLinkEvent('perks: pxcc enrolled: member banner');
    };
    return plccSwitch ? (React.createElement(Grid, { container: true, className: "PerkPLCC__boxEnrolled", onClick: handleBannerClick },
        React.createElement(Grid, { item: true, className: "PerkPLCC__cardLogoBox", onClick: handleBannerClick },
            React.createElement(Grid, { className: "PerkPLCC__inner-circle" },
                activePxccFactor,
                "X"),
            React.createElement(LazyImage, { src: getImageURL('PrgDetails/card.png'), classes: "PerkPLCC__cardLogo", altText: "Top banner, Home Depot store" })),
        React.createElement(Grid, { item: true, className: "PerkPLCC__LabelBoxLeft" },
            React.createElement(Grid, { className: "PerkPLCC__LabelHeading" }, pkPLCCBanner.plccCardMember),
            React.createElement(Grid, { className: "PerkPLCC__LabelSubHeading" },
                "You\u2019re Earning ",
                activePxccFactor,
                "X Towards Perks")))) : (React.createElement(Grid, { container: true, className: "PerkPLCC__boxMobileCard" },
        React.createElement(Grid, { item: true, className: "PerkPLCC__LabelBoxALeft" },
            React.createElement(Grid, { className: "PerkPLCC__LabelHeading" },
                "Earn Pro Xtra Perks ",
                activePxccFactor,
                "X Faster"),
            React.createElement(Grid, { className: "PerkPLCC__LabelSubHeading", onClick: function () {
                    setOverlayEvent('pro xtra credit card details');
                    setTogglePLCC(true);
                } },
                React.createElement("span", { className: "PerkPLCC__cardMobileLearnMore" }, "Learn more "))),
        React.createElement(Grid, { item: true, className: "PerkPLCC__cardMobileLogoContainer" },
            React.createElement(LazyImage, { src: getImageURL('mobile-PLCC-card-with-shadow.png'), classes: "PerkPLCC__cardMobileLogo", altText: "Top banner, Home Depot store" }))));
};
